import {
  List,
  ListItem,
  ListItemText,
  IconButton,
  Badge,
  Box,
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import classNames from 'classnames'
import { KWireListProps } from './KWireTypes'
import './KWireList.scss'

function KWireList({
  items,
  onRemoveItem,
  className,
  itemClassName,
}: KWireListProps) {
  return (
    <Box className={classNames(className, 'kwire-list')}>
      <List dense>
        {items.length === 0 ? (
          <ListItem className={itemClassName}>
            <ListItemText primary="No items added" />
          </ListItem>
        ) : (
          items.map((item) => (
            <ListItem
              key={item.id}
              className={classNames(itemClassName, 'kwire-list-item')}
              secondaryAction={
                <IconButton
                  edge="end"
                  className="kwire-list-item-delete-button"
                  aria-label="delete"
                  onClick={() => onRemoveItem(item.id)}
                >
                  <DeleteIcon />
                </IconButton>
              }
            >
              <Box className="kwrite-item-content">
                <ListItemText
                  primary={
                    <Box className="kwire-name-with-badge">
                      <Badge
                        badgeContent={item.count}
                        color="primary"
                        className="kwire-list-item-badge"
                      />
                      <span>{item.name}</span>
                    </Box>
                  }
                />
              </Box>
            </ListItem>
          ))
        )}
      </List>
    </Box>
  )
}

export default KWireList
